// requiredLegalAge years and more - legal
export const ValidateLegalDobRule = (message, requiredLegalAge) => ({
  message,
  name: 'validateLegalDob',
  validate: (userAge) => {
    const dateFormatUserAge = new Date(userAge);
    const minAgeDate = new Date();

    minAgeDate.setFullYear(minAgeDate.getFullYear() - requiredLegalAge);

    return !(dateFormatUserAge > minAgeDate) || message;
  },
});
